import classes from "./Meeting.module.scss"
import BoldTitle from './../../../../Titles/BoldTitle/BoldTitle';
import Cards from "../../../../Cards/Cards";
import CircleColored from './../../../../CircleColored/CircleColored';
const Meeting = () => {
  return (
    <div className={classes.Meeting}>
      <CircleColored customClass={classes.Circle}/>
      <p className={classes.Preceding}>После всех изысканий мы устроили встречу с руководителями маркетингового отдела компании ТОПОЛ-ЭКО и рассказали обо всех найденных нами недостатках текущего сайта и результатах проведенного нами анализа.</p>
      <div className={classes.Wrap}>
        <BoldTitle customClass={classes.Meet} text={<>На этой встречи мы оговорили, что <span>наша задача</span>:</>} />
        <Cards
          customClass={classes.CardsPurpose}
          number={"01."}
          title={<>Остановить падение трафика и получить устойчивый рост.</>}
        />   <Cards
          customClass={classes.CardsPurpose}
          number={"02."}
          title={<>Увеличить конверсию сайта.</>}
        />
      </div>
    </div>
  )
}
export default Meeting;